import { Box, IconButton, MenuItem, Tooltip } from "@mui/material";
import { PushPin } from "@mui/icons-material";
import { useNavigation, useTranslation } from "@refinedev/core";
import { useWorkspaceStore } from "../../store/useWorkspaceStore";
import { CurrencyToggle } from "./CurrencyToggle";
import { useMarketplaceStore } from "../../store/useMarketplaceStore";
import { useCurrency } from "../../hooks/useCurrency";
import { AccountMenu, useCloseAccountMenu } from "./AccountMenu";

const WorkspaceToggle = () => {
  const close = useCloseAccountMenu();
  const { toggle: toggleWorkspace, items: workspaceItems } =
    useWorkspaceStore();

  return (
    <Tooltip title="Workspace">
      <IconButton
        color="inherit"
        onClick={() => {
          toggleWorkspace();
          close();
        }}
        sx={{ width: 34, height: 34, position: "relative" }}
      >
        <PushPin fontSize="small" />
        {workspaceItems.length > 0 && (
          <Box
            component="span"
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              width: 6,
              height: 6,
              borderRadius: "50%",
              bgcolor: "primary.main",
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};

const ExtensionMenuItem = () => {
  const close = useCloseAccountMenu();
  const { translate } = useTranslation();
  const { push } = useNavigation();

  return (
    <MenuItem
      onClick={() => {
        close();
        push("extension");
      }}
    >
      {translate("pages.layout.extension")}
    </MenuItem>
  );
};

export const UserMenu = () => {
  const selectedCountry = useMarketplaceStore((s) => s.selectedCountry);
  const { isLoading: isCurrencyLoading, settings: currencySettings } =
    useCurrency();
  const showCurrencyToggle = Boolean(
    selectedCountry?.currency &&
      selectedCountry.currency !== "$" &&
      !isCurrencyLoading &&
      currencySettings,
  );

  return (
    <AccountMenu
      menuId="account-menu"
      toolbarStart={showCurrencyToggle && <CurrencyToggle />}
      toolbarMiddle={<WorkspaceToggle />}
      menuItems={<ExtensionMenuItem />}
    />
  );
};
